function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "287",
  height: "287",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M287 219.498H0v.143h287v-.143zM136.038 193.897H25.204a3.276 3.276 0 01-3.272-3.277V34.819a3.278 3.278 0 013.272-3.249h110.834a3.28 3.28 0 013.278 3.277V190.62a3.278 3.278 0 01-3.278 3.277zM25.204 31.685a3.134 3.134 0 00-3.128 3.134V190.62a3.135 3.135 0 003.128 3.134h110.834a3.142 3.142 0 003.134-3.134V34.819a3.139 3.139 0 00-3.134-3.134H25.204zM260.2 193.897H149.361a3.281 3.281 0 01-3.278-3.277V34.819a3.281 3.281 0 013.278-3.249H260.2a3.277 3.277 0 013.266 3.249V190.62a3.277 3.277 0 01-3.266 3.277zM149.361 31.685a3.142 3.142 0 00-3.134 3.134V190.62a3.138 3.138 0 003.134 3.134H260.2a3.138 3.138 0 003.134-3.134V34.819a3.14 3.14 0 00-3.134-3.134H149.361zM258.242 228.733h-14.924v.144h14.924v-.144zM204.361 230.295h-25.847v.143h25.847v-.143zM242.745 223.407h-34.894v.143h34.894v-.143zM41.15 224.371H30.112v.143H41.15v-.143zM78 224.371H46.265v.143h31.737v-.143zM140.136 226.793H97.391v.144h42.745v-.144z",
  fill: "#EBEBEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.646 87.793H46.264v131.705h58.382V87.793z",
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.158 92.414H51.74v122.457h47.418V92.414z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.904 98.154H55.006v2.801h40.898v-2.801zM95.904 104.52H55.006v2.801h40.898v-2.801zM95.904 110.88H55.006v2.801h40.898v-2.801zM95.904 117.245H55.006v2.801h40.898v-2.801zM95.904 123.611H55.006v2.801h40.898v-2.801zM95.904 129.971H55.006v2.801h40.898v-2.801zM95.904 136.336H55.006v2.802h40.898v-2.802zM95.904 142.696H55.006v2.802h40.898v-2.802zM95.904 149.062H55.006v2.801h40.898v-2.801zM95.904 155.428H55.006v2.801h40.898v-2.801zM95.904 161.788H55.006v2.801h40.898v-2.801zM95.904 168.153H55.006v2.801h40.898v-2.801zM95.904 174.513H55.006v2.801h40.898v-2.801zM95.904 180.879H55.006v2.801h40.898v-2.801zM95.904 187.245H55.006v2.801h40.898v-2.801zM95.904 193.604H55.006v2.802h40.898v-2.802zM95.904 199.97H55.006v2.801h40.898v-2.801zM95.904 206.33H55.006v2.801h40.898v-2.801z",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.112 219.492h16.152V87.788H30.112v131.704z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.621 85.526H50.805v2.267H96.62v-2.267z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.13 87.793h12.675v-2.267H38.13v2.267z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.366 97.482c.967 0 1.75-1.912 1.75-4.27 0-2.359-.783-4.27-1.75-4.27s-1.75 1.911-1.75 4.27c0 2.358.783 4.27 1.75 4.27zM30.686 93.212c0 2.359.528 4.27 1.183 4.27.654 0 1.182-1.911 1.182-4.27 0-2.36-.528-4.242-1.183-4.242-.654 0-1.182 1.883-1.182 4.242zM43.366 218.344c.967 0 1.75-1.912 1.75-4.271 0-2.358-.783-4.27-1.75-4.27s-1.75 1.912-1.75 4.27c0 2.359.783 4.271 1.75 4.271zM30.686 214.102c0 2.365.528 4.276 1.183 4.276.654 0 1.182-1.911 1.182-4.276 0-2.365-.528-4.271-1.183-4.271-.654 0-1.182 1.883-1.182 4.271zM213.333 117.165h-45.357v102.327h45.357V117.165z",
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.074 120.758h-36.845v95.146h36.845v-95.146z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.542 125.218h-31.776v2.176h31.776v-2.176zM206.542 130.166h-31.776v2.175h31.776v-2.175zM206.542 135.108h-31.776v2.176h31.776v-2.176zM206.542 140.05h-31.776v2.176h31.776v-2.176zM206.542 144.998h-31.776v2.176h31.776v-2.176zM206.542 149.94h-31.776v2.176h31.776v-2.176zM206.542 154.882h-31.776v2.176h31.776v-2.176zM206.542 159.83h-31.776v2.176h31.776v-2.176zM206.542 164.772h-31.776v2.176h31.776v-2.176zM206.542 169.715h-31.776v2.175h31.776v-2.175zM206.542 174.662h-31.776v2.176h31.776v-2.176zM206.542 179.605h-31.776v2.175h31.776v-2.175zM206.542 184.547h-31.776v2.175h31.776v-2.175zM206.542 189.495h-31.776v2.175h31.776v-2.175zM206.542 194.437h-31.776v2.175h31.776v-2.175zM206.542 199.379h-31.776v2.175h31.776v-2.175zM206.542 204.327h-31.776v2.175h31.776v-2.175zM206.542 209.269h-31.776v2.175h31.776v-2.175z",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.428 219.498h12.548V117.171h-12.548v102.327z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.105 115.408h-35.6v1.763h35.6v-1.763z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.65 117.165h9.85v-1.762h-9.85v1.762z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.365 121.378c0 1.837.608 3.324 1.354 3.324.747 0 1.361-1.487 1.361-3.324 0-1.837-.609-3.318-1.361-3.318s-1.354 1.487-1.354 3.318zM155.87 121.378c0 1.837.413 3.324.918 3.324.505 0 .924-1.487.924-3.324 0-1.837-.413-3.318-.924-3.318-.511 0-.918 1.487-.918 3.318zM164.365 215.284c0 1.837.608 3.318 1.354 3.318.747 0 1.361-1.481 1.361-3.318 0-1.836-.609-3.317-1.361-3.317s-1.354 1.486-1.354 3.317zM155.87 215.284c0 1.837.413 3.318.918 3.318.505 0 .924-1.481.924-3.318 0-1.836-.413-3.317-.924-3.317-.511 0-.918 1.486-.918 3.317z",
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.719 121.688H138.96a6.697 6.697 0 01-6.693-6.687v-9.041a6.127 6.127 0 00-6.113-6.118H104.64v-.574h21.514a6.698 6.698 0 016.687 6.692v9.018a6.11 6.11 0 001.788 4.336 6.122 6.122 0 004.331 1.8h26.759v.574zM156.788 215.571h-8.122a6.694 6.694 0 01-4.725-1.962 6.694 6.694 0 01-1.962-4.725V156.34a6.125 6.125 0 00-6.119-6.113h-31.22v-.574h31.243a6.703 6.703 0 016.693 6.687v52.544a6.126 6.126 0 006.09 6.113h8.099l.023.574z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.761 56.66H217.46v3.1h30.301v-3.1z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.074 59.765h8.386v-3.1h-8.386v3.1z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.761 49.071H217.46v3.1h30.301v-3.1z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.074 52.165h8.386v-3.1h-8.386v3.1z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.761 41.477H217.46v3.1h30.301v-3.1z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.074 44.577h8.386v-3.1h-8.386v3.1z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.761 33.883H217.46v3.1h30.301v-3.1z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.074 36.983h8.386v-3.1h-8.386v3.1z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("g", {
  opacity: ".4"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M244.742 26.169H219.17v30.496h25.572V26.17z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M212.093 56.66h7.077V26.163h-7.077V56.66z",
  fill: "#E0E0E0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M169.548 107.074H147.42v2.262h22.128v-2.262z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.302 109.336h6.118v-2.262h-6.118v2.262z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.548 101.529H147.42v2.262h22.128v-2.262z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.302 103.791h6.118v-2.262h-6.118v2.262z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.548 95.984H147.42v2.262h22.128v-2.262z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.302 98.252h6.118V95.99h-6.118v2.262z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.548 90.44H147.42V92.7h22.128v-2.262z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.302 92.707h6.118v-2.262h-6.118v2.262z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("g", {
  opacity: ".4"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M167.344 84.808h-18.672v22.266h18.672V84.808z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M143.506 107.074h5.166V84.808h-5.166v22.266z",
  fill: "#E0E0E0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M271.376 178.83h-28.517v2.916h28.517v-2.916z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.973 181.746h7.886v-2.916h-7.886v2.916z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.376 171.683h-28.517v2.916h28.517v-2.916z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.973 174.599h7.886v-2.916h-7.886v2.916z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.376 164.537h-28.517v2.916h28.517v-2.916z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.973 167.459h7.886v-2.916h-7.886v2.916z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.376 157.397h-28.517v2.915h28.517v-2.915z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.973 160.307h7.886v-2.916h-7.886v2.916z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("g", {
  opacity: ".4"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M268.535 150.13h-24.068v28.7h24.068v-28.7z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M237.814 178.83h6.658v-28.7h-6.658v28.7z",
  fill: "#E0E0E0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M143.5 245.419c61.465 0 111.293-2.909 111.293-6.497 0-3.589-49.828-6.498-111.293-6.498-61.466 0-111.293 2.909-111.293 6.498 0 3.588 49.827 6.497 111.293 6.497z",
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245.31 66.17h-62.502v59.949h62.502V66.171z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M245.31 66.17h-62.502v59.949h62.502V66.171z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".7",
  d: "M245.304 66.17h-42.602v59.949h42.602V66.171z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.175 69.23h-38.343v7.422h38.343V69.23zM243.175 78.512h-38.343v7.421h38.343v-7.421zM243.175 87.793h-38.343v7.422h38.343v-7.422zM243.175 97.07h-38.343v7.421h38.343v-7.422zM243.175 106.351h-38.343v7.422h38.343v-7.422zM243.175 115.632h-38.343v7.422h38.343v-7.422zM200.475 69.23H185.04v7.422h15.435V69.23zM200.475 78.512H185.04v7.421h15.435v-7.421zM200.475 87.793H185.04v7.422h15.435v-7.422zM200.475 97.07H185.04v7.421h15.435v-7.422zM200.475 106.351H185.04v7.422h15.435v-7.422zM200.475 115.632H185.04v7.422h15.435v-7.422z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M193.708 70.717h-7.244v4.454h7.244v-4.454zM193.708 79.993h-7.244v4.454h7.244v-4.454zM193.708 89.274h-7.244v4.454h7.244v-4.454zM193.708 98.556h-7.244v4.454h7.244v-4.454zM193.708 107.837h-7.244v4.455h7.244v-4.455zM193.708 117.119h-7.244v4.454h7.244v-4.454z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".7",
  d: "M241.298 70.195h-.896v5.487h.896v-5.487zM239.576 70.195h-.895v5.487h.895v-5.487zM237.854 70.195h-.896v5.487h.896v-5.487zM236.132 70.195h-.896v5.487h.896v-5.487zM234.41 70.195h-.895v5.487h.895v-5.487zM241.298 79.476h-.896v5.487h.896v-5.487zM239.576 79.476h-.895v5.487h.895v-5.487zM237.854 79.476h-.896v5.487h.896v-5.487zM236.132 79.476h-.896v5.487h.896v-5.487zM234.41 79.476h-.895v5.487h.895v-5.487zM241.298 88.758h-.896v5.487h.896v-5.487zM239.576 88.758h-.895v5.487h.895v-5.487zM237.854 88.758h-.896v5.487h.896v-5.487zM236.132 88.758h-.896v5.487h.896v-5.487zM234.41 88.758h-.895v5.487h.895v-5.487zM241.298 98.04h-.896v5.492h.896v-5.493zM239.576 98.04h-.895v5.492h.895v-5.493zM237.854 98.04h-.896v5.492h.896v-5.493zM236.132 98.04h-.896v5.492h.896v-5.493zM234.41 98.04h-.895v5.492h.895v-5.493zM241.298 107.321h-.896v5.493h.896v-5.493zM239.576 107.321h-.895v5.493h.895v-5.493zM237.854 107.321h-.896v5.493h.896v-5.493zM236.132 107.321h-.896v5.493h.896v-5.493zM234.41 107.321h-.895v5.493h.895v-5.493zM241.298 116.602h-.896v5.488h.896v-5.488zM239.576 116.602h-.895v5.488h.895v-5.488zM237.854 116.602h-.896v5.488h.896v-5.488zM236.132 116.602h-.896v5.488h.896v-5.488zM234.41 116.602h-.895v5.488h.895v-5.488z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M218.946 119.346a.916.916 0 01.564-.843.913.913 0 11-.564.843zM213.207 119.346a.915.915 0 01.563-.843.914.914 0 011.244.665.91.91 0 11-1.807.178z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M207.466 119.346a.916.916 0 01.564-.843.913.913 0 11-.564.843zM218.946 110.064a.918.918 0 01.564-.843.913.913 0 11-.564.843z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M213.207 110.064a.916.916 0 011.558-.645.915.915 0 01-.139 1.404.912.912 0 01-1.419-.759z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M207.466 110.064a.918.918 0 01.564-.843.913.913 0 11-.564.843z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M218.946 100.783a.914.914 0 111.827.001.914.914 0 01-1.827-.001z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M213.207 100.783a.913.913 0 111.825-.002.913.913 0 01-1.825.002z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M207.466 100.783a.914.914 0 111.827.001.914.914 0 01-1.827-.001z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M218.946 91.501a.913.913 0 111.825 0 .913.913 0 01-1.825 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M213.207 91.501a.913.913 0 111.825 0 .913.913 0 01-1.825 0zM207.466 91.501a.913.913 0 111.825 0 .913.913 0 01-1.825 0zM218.946 82.22a.915.915 0 011.091-.895.91.91 0 01.665 1.244.912.912 0 01-1.756-.35z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M213.207 82.22a.914.914 0 01.563-.843.912.912 0 11-.563.843zM207.466 82.22a.915.915 0 011.091-.895.91.91 0 01.665 1.244.912.912 0 01-1.756-.35zM218.946 72.944a.919.919 0 01.56-.847.91.91 0 01.996.194.917.917 0 01.201.995.914.914 0 01-1.757-.342z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M213.207 72.944a.906.906 0 011.087-.901.918.918 0 01.72.715.91.91 0 01-.387.939.912.912 0 01-1.42-.753z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M207.466 72.944a.919.919 0 01.56-.847.91.91 0 01.996.194.917.917 0 01.201.995.914.914 0 01-1.757-.342z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.091 178.967H67.588v59.949h62.503v-59.949z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M130.091 178.967H67.588v59.949h62.503v-59.949z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".7",
  d: "M130.086 178.967H87.483v59.949h42.603v-59.949z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.956 182.033H89.613v7.421h38.343v-7.421zM127.956 191.314H89.613v7.422h38.343v-7.422zM127.956 200.59H89.613v7.422h38.343v-7.422zM127.956 209.872H89.613v7.421h38.343v-7.421zM127.956 219.153H89.613v7.422h38.343v-7.422zM127.956 228.435H89.613v7.422h38.343v-7.422zM85.256 182.033H69.821v7.421h15.435v-7.421zM85.256 191.314H69.821v7.422h15.435v-7.422zM85.256 200.59H69.821v7.422h15.435v-7.422zM85.256 209.872H69.821v7.421h15.435v-7.421zM85.256 219.153H69.821v7.422h15.435v-7.422zM85.256 228.435H69.821v7.422h15.435v-7.422z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M78.489 183.514h-7.244v4.454h7.243v-4.454zM78.489 192.795h-7.244v4.454h7.243v-4.454zM78.489 202.077h-7.244v4.454h7.243v-4.454zM78.489 211.358h-7.244v4.455h7.243v-4.455zM78.489 220.64h-7.244v4.454h7.243v-4.454zM78.489 229.921h-7.244v4.455h7.243v-4.455z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".7",
  d: "M126.079 182.997h-.895v5.493h.895v-5.493zM124.357 182.997h-.896v5.493h.896v-5.493zM122.635 182.997h-.895v5.493h.895v-5.493zM120.913 182.997h-.895v5.493h.895v-5.493zM119.191 182.997h-.896v5.493h.896v-5.493zM126.079 192.279h-.895v5.487h.895v-5.487zM124.357 192.279h-.896v5.487h.896v-5.487zM122.635 192.279h-.895v5.487h.895v-5.487zM120.913 192.279h-.895v5.487h.895v-5.487zM119.191 192.279h-.896v5.487h.896v-5.487zM126.079 201.56h-.895v5.488h.895v-5.488zM124.357 201.56h-.896v5.488h.896v-5.488zM122.635 201.56h-.895v5.488h.895v-5.488zM120.913 201.56h-.895v5.488h.895v-5.488zM119.191 201.56h-.896v5.488h.896v-5.488zM126.079 210.842h-.895v5.493h.895v-5.493zM124.357 210.842h-.896v5.493h.896v-5.493zM122.635 210.842h-.895v5.493h.895v-5.493zM120.913 210.842h-.895v5.493h.895v-5.493zM119.191 210.842h-.896v5.493h.896v-5.493zM126.079 220.123h-.895v5.488h.895v-5.488zM124.357 220.123h-.896v5.488h.896v-5.488zM122.635 220.123h-.895v5.488h.895v-5.488zM120.913 220.123h-.895v5.488h.895v-5.488zM119.191 220.123h-.896v5.488h.896v-5.488zM126.079 229.399h-.895v5.493h.895v-5.493zM124.357 229.399h-.896v5.493h.896v-5.493zM122.635 229.399h-.895v5.493h.895v-5.493zM120.913 229.399h-.895v5.493h.895v-5.493zM119.191 229.399h-.896v5.493h.896v-5.493z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M94.073 185.741a.913.913 0 11-1.827 0 .913.913 0 011.827 0zM99.813 185.741a.913.913 0 11-1.827 0 .913.913 0 011.827 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M105.553 185.741a.916.916 0 01-.564.843.913.913 0 11.564-.843zM94.073 195.022a.911.911 0 01-1.09.895.914.914 0 01-.666-1.244.916.916 0 01.843-.563.913.913 0 01.913.912z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M99.813 195.022a.911.911 0 01-1.091.895.915.915 0 01-.717-.717.912.912 0 111.808-.178z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M105.553 195.022a.914.914 0 11-1.827-.001.914.914 0 011.827.001z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M94.073 204.304a.913.913 0 11-1.827 0 .913.913 0 011.827 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M99.813 204.304a.913.913 0 11-1.827 0 .913.913 0 011.827 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M105.553 204.304a.916.916 0 01-.564.843.913.913 0 11.564-.843z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M94.073 213.585a.911.911 0 01-1.09.896.912.912 0 111.09-.896z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M99.813 213.585a.911.911 0 01-1.091.896.913.913 0 111.09-.896zM105.553 213.585a.914.914 0 11-1.827-.001.914.914 0 011.827.001zM94.073 222.867a.913.913 0 11-1.827 0 .913.913 0 011.827 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M99.813 222.867a.913.913 0 11-1.827 0 .913.913 0 011.827 0zM105.553 222.867a.916.916 0 01-.564.843.913.913 0 11.564-.843zM94.073 232.149a.913.913 0 11-1.827 0 .913.913 0 011.827 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M99.813 232.149a.913.913 0 11-1.827 0 .913.913 0 011.827 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M105.553 232.149a.916.916 0 01-.564.843.913.913 0 11.564-.843z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.857 126.119h-1.149v52.59h1.149v-52.59z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".7",
  d: "M187.887 209.51h-6.429v-1.148h6.429v1.148zm-13.317 0h-6.888v-1.148h6.888v1.148zm-13.776 0h-6.888v-1.148h6.888v1.148zm-13.776 0h-6.888v-1.148h6.888v1.148z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.433 176.832l-8.283 40.628a2.58 2.58 0 002.016 3.05c.445.09.906.062 1.336-.082l39.325-13.145a2.575 2.575 0 001.634-3.265 2.58 2.58 0 00-.739-1.115l-31.042-27.489a2.583 2.583 0 00-4.247 1.418z",
  fill: "#008AF5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.023 213.959l6.526-32.001a1.063 1.063 0 01.698-.777 1.057 1.057 0 011.024.203l24.447 21.646c.138.122.242.279.301.454a1.048 1.048 0 01-.669 1.331l-30.967 10.332a1.06 1.06 0 01-1.018-.207 1.056 1.056 0 01-.342-.981z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.921 191.521l.902 2.703.051.127 3.065 6.44a1.151 1.151 0 001.378.574l1.2-.402a1.15 1.15 0 00.746-1.291l-1.401-6.997-.034-.132-.907-2.704a1.146 1.146 0 00-1.424-.712l-2.87.953a1.146 1.146 0 00-.706 1.441zM216.03 204.04a2.033 2.033 0 11-1.784-1.387 2.024 2.024 0 011.784 1.387zM95.76 98.98c-2.87.833-15.991 13.271-9.321 19.712 6.67 6.44 21.731 7.301 25.468 3.472 3.737-3.828 4.351-13.276 0-21.329-2.692-4.977-16.147-7.4-16.147-1.854z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M95.76 98.98c-2.87.833-15.991 13.271-9.321 19.712 6.67 6.44 21.731 7.301 25.468 3.472 3.737-3.828 4.351-13.276 0-21.329-2.692-4.977-16.147-7.4-16.147-1.854z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.978 134.178v1.785c0 .643.081 1.298.161 1.946.153 1.294.396 2.575.729 3.835a23.024 23.024 0 001.303 3.621c.27.574.574 1.149.89 1.694.149.275.327.545.493.809.081.138.178.264.27.396l.241.356c0 .035-.063-.034-.224-.086a.615.615 0 00-.379-.034c-.091.068.305 0 .729-.219a14.13 14.13 0 002.939-2.25 72.207 72.207 0 005.74-6.348l.035-.04a1.726 1.726 0 012.188-.298 1.724 1.724 0 01.682 2.1 41.66 41.66 0 01-2.17 4.139 37.893 37.893 0 01-2.669 3.92 22.426 22.426 0 01-1.642 1.883 13.73 13.73 0 01-2.089 1.791 7.167 7.167 0 01-3.444 1.32 5.127 5.127 0 01-2.56-.425 5.67 5.67 0 01-1.957-1.469l-.442-.528c-.138-.167-.282-.328-.408-.5-.258-.338-.522-.677-.763-1.033a20.856 20.856 0 01-1.355-2.181c-.419-.746-.781-1.521-1.148-2.296-.367-.775-.62-1.584-.878-2.388a28.017 28.017 0 01-1.079-4.925 32.555 32.555 0 01-.201-2.514v-2.279l.034-.407a3.447 3.447 0 016.888.338l.086.287z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.779 137.76l-1.2-.482a3.253 3.253 0 00-2.48.029l-4.494 1.894-1.148 2.078c1.659 2.646 4.558 1.285 4.558 1.285l2.824.207a1.41 1.41 0 001.326-.7l1.32-2.296a1.418 1.418 0 00.11-1.17 1.41 1.41 0 00-.816-.845z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.763 128.496c2.089 1.274 4.236 10.378 4.236 10.378l-9.029 4.592s-3.846-9.839-2.05-12.468c1.866-2.749 3.789-4.368 6.843-2.502z",
  fill: "#E56300"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M114.507 135.343a9.255 9.255 0 01-.034 4.816l-6.504 3.301s-2.244-5.74-2.502-9.626c2.307-2.267 7.611-2.554 9.04 1.509z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.226 132.732c-.304 4.592-1.561 16.617-4.362 23.827-.798 2.049 2.106 3.139-1.079 5.166l-22.639-1.258c-1.911-1.578-.212-3.713-.344-4.752-1.148-8.656.528-11.337-1.722-30.359 3.309-.482 6.649-.724 9.993-.723a75.162 75.162 0 0110.602.625c1.527.236 3.117.54 4.557.85a6.345 6.345 0 014.994 6.624z",
  fill: "#E56300"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M84.981 134.477a9.146 9.146 0 012.87 3.696c.976 2.44-1.573 7.135-2.503 8.708.035-3.1.07-6.687-.367-12.404z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.022 129.724s-3.858 3.163-4.196 6.521c-3.49-2.675-7.508-8.53-4.759-11.612 2.888-.735 8.955 5.091 8.955 5.091zM103.515 130.706s2.968 2.542 3.014 5.521c1.952-2.583 1.952-9.04-1.86-10.986-2.893-.717-1.154 5.465-1.154 5.465z",
  fill: "#EE8C26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.726 209.619l4.913 2.589 7.095-11.893-4.914-2.589-7.094 11.893z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.345 210.916l-2.87-5.791a.464.464 0 00-.574-.241l-4.913 1.618a.928.928 0 00-.604.912.92.92 0 00.099.374c1.039 2.003 1.642 2.916 2.904 5.464.781 1.567 1.831 4.989 2.905 7.153 1.073 2.164 3.277 1.216 3.019.218-1.148-4.472-.333-6.756.138-8.685a1.522 1.522 0 00-.104-1.022z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M130.815 197.732l4.919 2.588-4.236 7.095-4.54-3.22 3.857-6.463z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.346 161.679s34.63-4.868 37.758 5.366c5.878 19.218-8.788 38.269-8.788 38.269l-6.739-3.696s7.101-15.877 4.564-25.36c-6.567-1.831-38.458 13.202-38.579-10.516a2.03 2.03 0 011.544-2.158l10.24-1.905z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".3",
  d: "M105.346 161.679s34.63-4.868 37.758 5.366c5.878 19.218-8.788 38.269-8.788 38.269l-6.739-3.696s7.101-15.877 4.564-25.36c-6.567-1.831-38.458 13.202-38.579-10.516a2.03 2.03 0 011.544-2.158l10.24-1.905z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.257 201.658l8.019 5.539 2.273-2.652-8.817-6.217-1.475 3.33z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.017 213.953l.063.028a.788.788 0 00.752-.12.453.453 0 00.165-.177.452.452 0 00.053-.236c0-.735-1.814-1.803-2.015-1.923a.136.136 0 00-.153.005.136.136 0 00-.053.144c.172.706.545 1.957 1.188 2.279zm-.838-2.021c.7.448 1.584 1.148 1.601 1.521a.2.2 0 01-.103.178.5.5 0 01-.5.092c-.373-.138-.734-.803-.998-1.791z",
  fill: "#407BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.076 211.863c.637.316 1.968.574 2.439.23a.478.478 0 00.162-.265.483.483 0 00-.03-.309.688.688 0 00-.419-.431c-.775-.315-2.262.414-2.325.448a.12.12 0 00-.053.044.11.11 0 00-.021.065.136.136 0 00.01.072.147.147 0 00.047.055c.061.035.124.066.19.091zm2.089-.516a.45.45 0 01.229.252c.058.167 0 .236-.045.276-.322.247-1.447.08-2.084-.218.511-.218 1.4-.517 1.86-.327l.04.017z",
  fill: "#407BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.888 159.055l-.718 2.055c-.091.161.092.333.362.35l24.028 1.418c.212 0 .39-.08.413-.212l.333-2.078c0-.144-.155-.276-.385-.293l-23.643-1.389a.435.435 0 00-.39.149z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.97 161.868l-.632-.034c-.126 0-.223-.081-.206-.161l.453-2.698c0-.075.132-.138.259-.126l.631.034c.126 0 .218.081.207.161l-.46 2.698c.006.126-.109.16-.252.126zM107.769 163.016l-.637-.034c-.127 0-.218-.081-.201-.161l.453-2.698a.232.232 0 01.105-.107.236.236 0 01.148-.019l.637.034c.126 0 .218.081.201.161l-.454 2.698c-.011.057-.109.126-.252.126zM98.418 162.442l-.637-.034c-.126 0-.218-.081-.2-.161l.453-2.698c0-.075.126-.138.252-.126l.637.034c.127 0 .218.081.201.155l-.453 2.698c-.017.086-.127.132-.253.132z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.743 114.025c.471 3.444.844 8.455-1.676 10.59a32.363 32.363 0 018.105 7.548.993.993 0 001.275.25.989.989 0 00.338-.324c2.916-4.592.878-6.848.878-6.848-2.221-.494-1.951-2.468-1.148-5.08l-7.772-6.136z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.157 126.2c.344 1.062.459 3.013-1.366 5.889a.989.989 0 01-1.613.075 34.998 34.998 0 00-6.28-6.269c2.371.672 5.7 3.938 7.124 5.517 1.004-.775 2.169-3.714 2.135-5.212z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M97.89 116.683l4.317 2.428 1.331 1.05a8.395 8.395 0 00-.574 3.398c-2.818-.803-6.05-4.557-5.074-6.876z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.858 105.96c-.907 5.643-1.412 8.036.758 11.48 3.266 5.247 10.395 5.126 12.966-.132 2.296-4.735 3.444-13.167-1.538-16.605a7.791 7.791 0 00-10.658 1.64 7.797 7.797 0 00-1.528 3.617z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.786 106.19c-.717-3.059-.361-8.225-6.136-7.938-5.372.264-8.644-.54-8.61 2.542-5.935 2.905-6.314 5.913-2.14 8.754 3.168.758 3.977-2.87 3.615-5.855 2.297 1.338 6.665-.574 8.714-.516 2.646.097 5.275 6.072 4.557 3.013z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".5",
  d: "M111.786 106.19c-.717-3.059-.361-8.225-6.136-7.938-5.372.264-8.644-.54-8.61 2.542-5.935 2.905-6.314 5.913-2.14 8.754 3.168.758 3.977-2.87 3.615-5.855 2.297 1.338 6.665-.574 8.714-.516 2.646.097 5.275 6.072 4.557 3.013z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M102.947 109.135a4.351 4.351 0 01-2.336-.66c.806.108 1.592.33 2.336.66zM103.085 108.739s-1.337-.184-1.877-.948a6.028 6.028 0 011.877.948z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.405 109.427c-.097.454.057.873.356.942.298.069.62-.247.717-.701.098-.453-.051-.872-.35-.941-.298-.069-.62.247-.723.7zM109.531 110.575c-.103.454.057.879.35.942.293.063.62-.247.723-.701.104-.453-.057-.872-.35-.941-.293-.069-.62.247-.723.7z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.116 109.869l1.148-.069s-.74.729-1.148.069z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.769 111.04c.172 1.124.496 2.219.964 3.255a1.99 1.99 0 01-1.682-.058l.718-3.197z",
  fill: "#EEC5A3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.738 114.53a4.765 4.765 0 00-.683-.08.134.134 0 00-.079.048.136.136 0 000 .174c.02.024.048.041.079.048a3.697 3.697 0 012.933 1.578.138.138 0 00.183.052.148.148 0 00.052-.19 3.836 3.836 0 00-2.485-1.63z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.419 110.064a4.17 4.17 0 001.67 2.721c1.188.856 2.296-.092 2.37-1.475.075-1.246-.447-3.191-1.842-3.496a1.882 1.882 0 00-1.709.53 1.869 1.869 0 00-.49 1.72z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.066 105.582a.282.282 0 00.322 0c1.039-.718 2.571-.173 2.583-.167a.273.273 0 00.189-.511c-.074 0-1.813-.648-3.082.224a.277.277 0 00-.112.175.278.278 0 00.043.204.22.22 0 00.057.075zM110.392 108.027a.28.28 0 00-.213.172.277.277 0 00.155.35 2.71 2.71 0 002.486-.189.272.272 0 00.073-.078.275.275 0 00-.389-.37 2.173 2.173 0 01-1.969.126.301.301 0 00-.143-.011z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.458 228.406l5.292-1.67-3.455-13.409-5.298 1.67 3.461 13.409z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.331 225.324l-6.142-2.038a.453.453 0 00-.574.23l-2.296 4.632a.9.9 0 00-.081.379c0 .131.028.26.083.379a.904.904 0 00.572.499c2.152.671 3.226.89 5.929 1.779 1.659.574 4.833 2.21 7.124 2.968 2.29.757 3.168-1.47 2.296-1.992-3.984-2.336-5.04-4.517-6.085-6.205a1.514 1.514 0 00-.826-.631z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  d: "M127.997 214.997l5.298-1.67 2.06 8.002-5.481.964-1.877-7.296z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.46 161.168s31.994 2.192 32.574 12.88c1.079 20.062 5.798 43.819 5.798 43.819l-7.365 2.187s-9.597-24.108-11.319-39.703c-5.935-3.358-35.014 8.334-32.144-18.075a1.924 1.924 0 012.02-1.722l10.436.614z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M135.136 216.901l.118.616-6.489 1.927-.247-.636a283.647 283.647 0 01-4.59-12.913c-2.613-7.972-5.428-17.856-6.283-25.599l-.028-.254-.223-.126c-.853-.483-2.06-.669-3.43-.722-1.385-.055-3.02.025-4.776.131l-1.015.062c-3.282.204-6.928.43-10.347.073-3.776-.393-7.18-1.49-9.474-4.026-2.285-2.526-3.56-6.583-2.851-13.104v-.003a1.425 1.425 0 011.495-1.274s0 0 0 0l10.43.614h.005l.016.001.068.005.264.02a114.99 114.99 0 014.627.481c2.999.371 6.997.976 11.01 1.913 4.019.938 8.02 2.202 11.041 3.877 3.044 1.688 4.948 3.71 5.078 6.111.541 10.055 1.993 21.029 3.308 29.483a439.718 439.718 0 001.742 10.373c.23 1.272.419 2.28.551 2.97z",
  fill: "#fff",
  stroke: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.577 221.001l9.58-1.796-.287-3.484-10.619 1.888 1.326 3.392z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.96 226.983l.063-.029a.761.761 0 00.442-.614.467.467 0 00-.138-.454c-.54-.493-2.554.029-2.784.086a.14.14 0 00-.067.042.14.14 0 00-.031.073.148.148 0 00.012.078.15.15 0 00.052.06c.631.384 1.773.987 2.451.758zm-2.021-.827c.809-.184 1.923-.327 2.204-.069a.208.208 0 01.058.201.51.51 0 01-.089.247.506.506 0 01-.198.172c-.362.166-1.085-.046-1.975-.551z",
  fill: "#407BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.813 226.185c.678-.236 1.808-.988 1.877-1.579a.477.477 0 00-.315-.505.714.714 0 00-.574 0c-.77.327-1.298 1.9-1.321 1.969a.12.12 0 00-.004.07.149.149 0 00.09.101c.022.008.046.01.069.007.061-.018.12-.039.178-.063zm1.102-1.854a.446.446 0 01.345 0c.155.074.166.16.16.229-.045.396-.964 1.079-1.618 1.32.201-.51.62-1.354 1.073-1.549h.04z",
  fill: "#407BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.99 108.721l1.148-.069s-.734.729-1.148.069z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.082 133.788a160.23 160.23 0 00-1.682 5.241 237.41 237.41 0 00-1.538 5.332c-.494 1.779-.919 3.57-1.326 5.355a70.656 70.656 0 00-1.005 5.35c-.21 1.693-.265 3.4-.166 5.103.086 1.808.206 3.656.396 5.51.361 3.703.815 7.462 1.285 11.193v.029a1.72 1.72 0 01-3.323.769 102.763 102.763 0 01-3.1-11.193c-.401-1.9-.775-3.828-1.027-5.803a29.934 29.934 0 01-.264-6.285 77.684 77.684 0 011.906-11.698c.447-1.914.95-3.8 1.51-5.66.573-1.877 1.147-3.702 1.853-5.602a3.438 3.438 0 011.764-1.961 3.448 3.448 0 014.594 1.623 3.45 3.45 0 01.14 2.634l-.017.063z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.074 125.339c-2.382.574-5.665 8.466-5.665 8.466l7.364 6.676s5.034-6.165 4.23-9.265c-.838-3.214-3.214-6.532-5.929-5.877z",
  fill: "#E56300"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.16 181.034l-.028-.161a3.578 3.578 0 00-1.877-2.566l-3.95-2.049-2.335.436c-.436 2.354 2.445 4.667 2.445 4.667l.631 1.332a1.997 1.997 0 002.469 1.039l1.337-.471a2.01 2.01 0 001.309-2.227z",
  fill: "#F4DAC4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.032 141.319c.477.505 1.504.315 2.296-.431.792-.746 1.039-1.756.574-2.261-.465-.505-1.504-.31-2.296.43-.792.741-1.056 1.757-.574 2.262z",
  fill: "#EF8432"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.103 143.5h-.086c-.103 0-2.526-.413-1.986-4.351a.585.585 0 01.223-.383.565.565 0 01.428-.113.579.579 0 01.497.651c-.385 2.778.993 3.059 1.01 3.059a.576.576 0 01.482.649.574.574 0 01-.568.488z",
  fill: "#EF8432"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.244 140.768c.282.298.988.092 1.567-.459.58-.551.833-1.24.574-1.539-.258-.298-.987-.097-1.567.454-.579.551-.855 1.24-.574 1.544z",
  fill: "#fff"
}))));